import { ZAlert } from '@zoryn/components/alert'
import { ZAutocomplete } from '@zoryn/components/autocomplete'
import { ZButton } from '@zoryn/components/button'
import { ZCard } from '@zoryn/components/card'
import { ZCascader } from '@zoryn/components/cascader'
import {
  ZCheckbox,
  ZCheckboxButton,
  ZCheckboxGroup,
} from '@zoryn/components/checkbox'
import { ZCol } from '@zoryn/components/col'
import { ZCollapse, ZCollapseItem } from '@zoryn/components/collapse'
import { ZColorPicker } from '@zoryn/components/color-picker'
import { ZDatePicker } from '@zoryn/components/date-picker'
import { ZDialog } from '@zoryn/components/dialog'
import { ZDivider } from '@zoryn/components/divider'
import { ZForm, ZFormItem } from '@zoryn/components/form'
import { ZIcon } from '@zoryn/components/icon'
import { ZImage } from '@zoryn/components/image'
import { ZInput } from '@zoryn/components/input'
import { ZInputNumber } from '@zoryn/components/input-number'
import { ZInputOtp } from '@zoryn/components/input-otp'
import { ZInputTag } from '@zoryn/components/input-tag'
import { ZMention } from '@zoryn/components/mention'
import { ZPopconfirm } from '@zoryn/components/popconfirm'
import { ZPopover } from '@zoryn/components/popover'
import { ZRadio, ZRadioButton, ZRadioGroup } from '@zoryn/components/radio'
import { ZRate } from '@zoryn/components/rate'
import { ZRow } from '@zoryn/components/row'
import { ZOption, ZOptionGroup, ZSelect } from '@zoryn/components/select'
import { ZSlider } from '@zoryn/components/slider'
import { ZSpace } from '@zoryn/components/space'
import { ZSwitch } from '@zoryn/components/switch'
import { ZTabPane, ZTabs } from '@zoryn/components/tabs'
import { ZTag } from '@zoryn/components/tag'
import { ZTimePicker } from '@zoryn/components/time-picker'
import { ZTimeSelect } from '@zoryn/components/time-select'
import { ZTooltip } from '@zoryn/components/tooltip'
import { ZTransfer } from '@zoryn/components/transfer'
import { ZTree } from '@zoryn/components/tree'
import { ZTreeSelect } from '@zoryn/components/tree-select'
import { ZUpload } from '@zoryn/components/upload'

import type { Component } from 'vue'

export type FormCreateLike = {
  component: (name: string, component: Component) => unknown
}

const Z_COMPONENTS: Array<[string, Component]> = [
  ['ZAlert', ZAlert],
  ['ZAutocomplete', ZAutocomplete],
  ['ZButton', ZButton],
  ['ZCard', ZCard],
  ['ZCascader', ZCascader],
  ['ZCheckbox', ZCheckbox],
  ['ZCheckboxButton', ZCheckboxButton],
  ['ZCheckboxGroup', ZCheckboxGroup],
  ['ZCol', ZCol],
  ['ZCollapse', ZCollapse],
  ['ZCollapseItem', ZCollapseItem],
  ['ZColorPicker', ZColorPicker],
  ['ZDatePicker', ZDatePicker],
  ['ZDialog', ZDialog],
  ['ZDivider', ZDivider],
  ['ZForm', ZForm],
  ['ZFormItem', ZFormItem],
  ['ZIcon', ZIcon],
  ['ZImage', ZImage],
  ['ZInput', ZInput],
  ['ZInputNumber', ZInputNumber],
  ['ZInputOtp', ZInputOtp],
  ['ZInputTag', ZInputTag],
  ['ZMention', ZMention],
  ['ZPopconfirm', ZPopconfirm],
  ['ZPopover', ZPopover],
  ['ZRadio', ZRadio],
  ['ZRadioButton', ZRadioButton],
  ['ZRadioGroup', ZRadioGroup],
  ['ZRate', ZRate],
  ['ZRow', ZRow],
  ['ZSelect', ZSelect],
  ['ZOption', ZOption],
  ['ZOptionGroup', ZOptionGroup],
  ['ZSlider', ZSlider],
  ['ZSpace', ZSpace],
  ['ZSwitch', ZSwitch],
  ['ZTabs', ZTabs],
  ['ZTabPane', ZTabPane],
  ['ZTag', ZTag],
  ['ZTimePicker', ZTimePicker],
  ['ZTimeSelect', ZTimeSelect],
  ['ZTooltip', ZTooltip],
  ['ZTransfer', ZTransfer],
  ['ZTree', ZTree],
  ['ZTreeSelect', ZTreeSelect],
  ['ZUpload', ZUpload],
]

const KEBAB_FIELDS: Array<[string, Component]> = [
  ['date-picker', ZDatePicker],
  ['input-number', ZInputNumber],
  ['color-picker', ZColorPicker],
  ['time-picker', ZTimePicker],
  ['time-select', ZTimeSelect],
  ['tree-select', ZTreeSelect],
  ['input-tag', ZInputTag],
  ['input-otp', ZInputOtp],
  ['elAlert', ZAlert],
  ['elButton', ZButton],
  ['elCard', ZCard],
  ['elCollapse', ZCollapse],
  ['elCollapseItem', ZCollapseItem],
  ['elDivider', ZDivider],
  ['elImage', ZImage],
  ['elTag', ZTag],
  ['elTabs', ZTabs],
  ['elTabPane', ZTabPane],
  ['space', ZSpace],
]

export function registerZorynComponents(fc: FormCreateLike) {
  for (const [name, component] of Z_COMPONENTS) {
    fc.component(name, component)
  }
  for (const [name, component] of KEBAB_FIELDS) {
    fc.component(name, component)
  }
}
